/**
 * i18n.js - 国际化加载器 (Data Charts 专用版)
 * 负责加载 locales/*.json 并处理构建期包装
 */

let currentLang = 'en';
let translations = {};

/**
 * 对应 vite.config.js 中的 locale transform。
 * 这只用于语言包，不再用于 data API payload。
 */
function decodeLocalePayload(data) {
    try {
        // 1. 检查是否有安全标记 _s
        if (data && data._s && data._d) {
            // 2. 反转字符串 (还原混淆)
            const reversed = data._d.split('').reverse().join('');

            // 3. [⭐ 核心修复] 使用 TextDecoder 解决中文乱码问题
            // 浏览器原生的 atob 只能处理 Latin-1，遇到中文会乱码
            const binaryString = atob(reversed);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            // 使用 UTF-8 解码器将字节流转回中文
            const jsonString = new TextDecoder('utf-8').decode(bytes);

            // 4. 解析为对象
            return JSON.parse(jsonString);
        }
        return data;
    } catch (e) {
        console.error('[i18n] Locale decode failed:', e);
        return {};
    }
}
/**
 * [⭐ 修改] 获取当前语言
 * 逻辑升级：优先使用 PHP 注入的配置 > URL参数 > localStorage > 浏览器 > 默认
 */
function detectLanguage() {
    // 1. 最高优先级：PHP 服务端下发的语言（确保前后端一致）
    if (window.OMA_CONFIG && window.OMA_CONFIG.lang) {
        console.log(`[i18n] Syncing with PHP: ${window.OMA_CONFIG.lang}`);
        return window.OMA_CONFIG.lang;
    }

    // 2. 备选：浏览器语言
    const navLang = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
    return navLang.startsWith('zh') ? 'zh' : 'en';
}


/**
 * 初始化 i18n
 */
export async function initI18n() {
    currentLang = detectLanguage();
    console.log(`[i18n] Initializing language: ${currentLang}`);

    try {
        // [⭐ 修改核心] 构建完整 URL
        // 默认回退到 ./locales/ 以防 PHP 配置缺失（本地开发时）
        let fetchUrl = `./locales/${currentLang}.json`;

        if (window.OMA_CONFIG && window.OMA_CONFIG.locale_base) {
            // 如果 PHP 给了 CDN 路径，就用 CDN 路径
            fetchUrl = `${window.OMA_CONFIG.locale_base}${currentLang}.json`;
        }

        // 添加时间戳防止缓存
        const response = await fetch(`${fetchUrl}?v=${new Date().getTime()}`);

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const rawData = await response.json();
        translations = decodeLocalePayload(rawData);

    } catch (error) {
        console.warn(`[i18n] Failed to load ${currentLang}, falling back to empty.`, error);
        translations = {};
    }
}

/**
 * 获取翻译文本
 * @param {string} key - 键路径，如 "chart_labels.BTC"
 * @param {string} defaultVal - 默认值（可选）
 */
export function t(key, defaultVal = '') {
    const keys = key.split('.');
    let value = translations;

    for (const k of keys) {
        if (value && value[k] !== undefined) {
            value = value[k];
        } else {
            return defaultVal || key; // 找不到 key 时返回 key 本身或默认值
        }
    }
    return value;
}

/**
 * 获取当前语言代码
 */
export function getLang() {
    return currentLang;
}
